var render = function render(){var _vm=this,_c=_vm._self._c;return _c('work-item-detail',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"widgets",fn:function({ workItem }){return [(_vm.isAvailable(workItem))?_c('agent-plan',{attrs:{"work-item-id":workItem.id,"can-update":workItem.userPermissions?.updateWorkItem,"content":''},on:{"save":() => {}}}):_vm._e()]}}])},'work-item-detail',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }